import * as React from 'react';
import type { FC } from 'react';
import { useLocales } from './locales';

const Rules: FC = () => {
  const l = useLocales();

  return (
    <div className="j-w_how jw-how" aria-labelledby="how-to-win">
      <div className="jw-how_wrapper">
        <h2 className="jw-how_title" id="how-to-win">
          {l('how_to_win')}
        </h2>
        <ul className="jw-how_list">
          <li className="jw-how_item">
            <div className="jw-how_number">
              <span>1</span>
            </div>
            <div className="jw-how_text">
              <p>{l('choose_game')}</p>
            </div>
            <div className="jw-how_image jw-how_image__bandit">
              <img src="/images/jackpot/bandit.png" alt="" />
            </div>
          </li>
          <li className="jw-how_item">
            <div className="jw-how_number">
              <span>2</span>
            </div>
            <div className="jw-how_text">
              <p>{l('make_bets')}</p>
            </div>
            <div className="jw-how_image jw-how_image__coins">
              <img src="/images/jackpot/coins.png" alt="" />
            </div>
          </li>
          <li className="jw-how_item">
            <div className="jw-how_number">
              <span>3</span>
            </div>
            <div className="jw-how_text">
              <p>{l('play_and_win')}</p>
            </div>
            <div className="jw-how_image jw-how_image__money">
              <img src="/images/jackpot/money.png" alt="" />
            </div>
          </li>
        </ul>
        <div className="jw-how_links">
          <a href="/casino/search?badge=jackpot">{l('play')}</a>
        </div>
      </div>
    </div>
  );
};
export default Rules;
